// Текст на ЕДИН ред, отрязан с „…" — и пълният текст в `title`, за да се
// прочете при посочване (и при дълго задържане на таблет). Без него отрязаното
// име в тесен ред („Доматено пюре Кюфтета…") няма как да се види цяло.
// `children` е видимото (име + приглушен суфикс), `text` — пълният текст за
// подсказката; без `children` се показва `text`.
import type { ReactNode } from "react";

type Props = {
  text: string;
  children?: ReactNode;
  className?: string;
};

export const TruncatedText = ({ text, children, className = "" }: Props) => (
  <span title={text} className={`block min-w-0 truncate ${className}`}>
    {children ?? text}
  </span>
);

export default TruncatedText;
